import {
  FOC_REQUIRED_DISPOSITION,
  IOC_CARRYOVER_DISPOSITION,
} from '../orgWorkspaceTour/orgWorkspaceTourSteps';

export { FOC_REQUIRED_DISPOSITION, IOC_CARRYOVER_DISPOSITION };

export type FocPlnTourStepDef = {
  id: string;
  requirementId?: string;
  title: string;
  disposition?: string;
  description: string;
  bullets?: string[];
  tour?: string;
};

export type RequirementInput = Omit<
  FocPlnTourStepDef,
  'title' | 'requirementId'
> & {
  requirementId: string;
  name: string;
};

export function requirement({
  requirementId,
  name,
  ...rest
}: RequirementInput): FocPlnTourStepDef {
  return {
    ...rest,
    requirementId,
    title: `${requirementId} — ${name}`,
  };
}

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

export function focPlnTourPopoverHtml(
  step: Pick<FocPlnTourStepDef, 'disposition' | 'description' | 'bullets'>
): string {
  const body = `<p>${escapeHtml(step.description)}</p>`;
  const bullets = step.bullets?.length
    ? `<ul>${step.bullets
        .map((bullet) => `<li>${escapeHtml(bullet)}</li>`)
        .join('')}</ul>`
    : '';
  const content = `${body}${bullets}`;
  if (!step.disposition) return content;
  return `<p><strong>Disposition:</strong> ${escapeHtml(step.disposition)}</p>${content}`;
}
